import React, {useState} from "react";
import styles from './FJMediaCollectionItem.module.less';
import FJImage from "fj-components/FJImage";
import FJLocalStore from "../../../../store/FJLocalStore";
import FJKeyword from '../../../../common/component/FJKeyword'

function Mask(props) {
	const {styles, text} = props;
	return (
		<>
			<i className={styles.item_mask}/>
			<span className={styles.name}>{text}</span>
		</>
	);
}

function FJMediaCollectionItem(props) {

	const {onSearch} = props;
	const {name, url, keywords, width, height, hasShadow, previewHeight} = props;
	const [thumbnailStatus, updateStatus] = useState('error');
	const localName = FJLocalStore._(name.replace(/-/g, ' '));

	return (
		<li className={styles.li_container}
		    onClick={() => {onSearch(name, localName)}}
		    style={{width, height}}
		>
			<div className={styles.list_content}>
				{ hasShadow && <div className={styles.back_ele}><div className={styles.back_ele}/></div> }
				<div className={styles.item_top} style={{height: previewHeight}}>
					<FJImage url={url} imgAdapt='cover' setImgLoadStatus={updateStatus}/>
					{ thumbnailStatus === 'success' && <Mask styles={styles} text={localName} /> }
				</div>
				{
					keywords && (
						<div className={styles.item_bottom}>
							{keywords.map(text => <FJKeyword key={text} text={text} onClick={(value) => {onSearch(value, value)}} />)}
						</div>
					)
				}
			</div>
		</li>
	)
}

export default FJMediaCollectionItem;